import type { ReactNode } from 'react';

import ActionButton from '@/components/Button/ActionButton';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { cn } from '@/lib/cn';
import { UnescapedTrans } from '@/lib/i18n';

type ImageDialogProps = {
  title: string | ReactNode;
  image: {
    url: string;
    alt: string;
  };
  /** controlled mode: 外部から開閉を制御する場合に指定 */
  open?: boolean;
  /** controlled mode: 開閉状態の変更コールバック */
  onOpenChange?: (open: boolean) => void;
  /** DialogContent に追加する className */
  contentClassName?: string;
  /** img 要素に追加する className */
  imageClassName?: string;
};

const ImageDialog = ({
  title,
  image,
  open,
  onOpenChange,
  contentClassName,
  imageClassName,
}: ImageDialogProps) => {
  const isControlled = open !== undefined;

  const titleElement =
    typeof title === 'string' ? (
      <UnescapedTrans>{title}</UnescapedTrans>
    ) : (
      title
    );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {!isControlled && (
        <DialogTrigger>
          <ActionButton variant="outline" icon="ImageIcon" iconColor="muted" />
        </DialogTrigger>
      )}
      <DialogContent className={cn(contentClassName)}>
        <DialogHeader>
          <DialogTitle>{titleElement}</DialogTitle>
        </DialogHeader>
        <img src={image.url} alt={image.alt} className={cn(imageClassName)} />
      </DialogContent>
    </Dialog>
  );
};

export default ImageDialog;
